import React from 'react';
import { MetaText } from "@hm-group/fabric-components/components/Typography";
import cn from 'classnames';
import { SWATCHES_LIMIT } from './constants';
import "./ProductSwatches.css";
var styles = { "swatchesContainer": "dd8e72", "hm": "d458b9", "northstar-small": "fe1738", "northstar-large": "e4f217", "swatchesList": "c034b6", "swatch": "cd8a58", "swatchHighlight": "ba870c", "carouselLayout": "a41398" };
import { MIN_PRODUCT_VARIANTS } from '../ProductVariants/constants';
const ProductSwatches = ({ swatches, shouldShowRemainNumberAsLink, swatchesTotal, minNumberOfSwatches = 1, variant = 'hm', linkClickCallback, layout, productVariants, }) => {
    var _a;
    const numberOfSwatches = (_a = swatchesTotal !== null && swatchesTotal !== void 0 ? swatchesTotal : swatches === null || swatches === void 0 ? void 0 : swatches.length) !== null && _a !== void 0 ? _a : 0;
    const isCarouselLayout = layout === 'big_carousel' && productVariants && productVariants.length >= MIN_PRODUCT_VARIANTS;
    if (numberOfSwatches <= minNumberOfSwatches)
        return null;
    const renderRemainingComponent = () => {
        var _a, _b;
        if (numberOfSwatches <= SWATCHES_LIMIT)
            return null;
        const remainingProps = {
            className: styles[variant],
            Tag: (shouldShowRemainNumberAsLink ? 'a' : 'span'),
            href: shouldShowRemainNumberAsLink ? (_a = swatches === null || swatches === void 0 ? void 0 : swatches[SWATCHES_LIMIT]) === null || _a === void 0 ? void 0 : _a.colorLink : undefined,
            title: shouldShowRemainNumberAsLink ? (_b = swatches === null || swatches === void 0 ? void 0 : swatches[SWATCHES_LIMIT]) === null || _b === void 0 ? void 0 : _b.colorName : undefined,
            onClick: shouldShowRemainNumberAsLink
                ? linkClickCallback
                : undefined,
        };
        return React.createElement(MetaText, Object.assign({}, remainingProps), `+${numberOfSwatches - SWATCHES_LIMIT}`);
    };
    return (React.createElement("div", { className: cn(styles.swatchesContainer, styles[variant], isCarouselLayout && styles.carouselLayout) },
        swatches && (React.createElement("ul", { className: cn(styles.swatchesList, styles[variant]) }, swatches.slice(0, SWATCHES_LIMIT).map((swatch) => (React.createElement("li", { className: styles.item, key: swatch.hexColor },
            React.createElement("a", { href: swatch.colorLink, className: styles.swatch, style: { backgroundColor: swatch.hexColor }, title: swatch.colorName, onClick: linkClickCallback }, swatch.colorName)))))),
        renderRemainingComponent()));
};
export default ProductSwatches;
//# sourceMappingURL=ProductSwatches.js.map